<script>
	import { creds } from './stores';
	import { onMount } from 'svelte';
	import { resultsMap } from './lib';
	import { LottiePlayer } from '@lottiefiles/svelte-lottie-player';
	export let image;
	export let image2;

	import { createEventDispatcher } from 'svelte'
	const dispatch = createEventDispatcher();

	function getBase64(file) {
	  return new Promise((resolve, reject) => {
	    const reader = new FileReader();
	    reader.readAsDataURL(file);
	    reader.onload = () => resolve(reader.result);
	    reader.onerror = error => reject(error);
	  });
	}

	let dataURL, dataURL2, result = '';
	$: if (image) dataURL = getBase64(image);
	$: if (image2) dataURL2 = getBase64(image2);
	$: if (dataURL && dataURL2) send(dataURL, dataURL2);

	async function send(url, url2) {
		url = await url;
		url2 = await url2;

		var response = await fetch("/client_id");
		if(!response.ok) return result = {status: -1, result: 'Error ' + response.status};
		let client_id = await response.text();
		if(!client_id) return result = 'Error ' + response.status;

		var response = await fetch("/tokens");
		if(!response.ok) return result = {status: -1, result: 'Error ' + response.status};
		let tokens = await response.json();
		if(!tokens) return result = 'Error ' + response.status;

		response = await fetch(
			"/api/v1/authentication/compare-photos-task",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `${tokens.token_type} ${tokens.access_token}`,
				},
				redirect: "follow",
				body: JSON.stringify({
				  "photo_from_camera": {
				      "front": url
				  },
				  "photo_from_passport": url2,
				  "client_id": client_id,
				  "liveness": false,
				  "comparison": true,
				  "agreed_on_terms": true
				}),
			}
		);
		if(!response.ok) return result = {status: -1, result: 'Error ' + response.status};
		let job_id = (await response.json()).job_id;
		if(!job_id) return result = 'Error ' + response.status;

		async function checkLoop() {
			response = await fetch(
				"/api/v1/authentication/compare-photos-status",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `${tokens.token_type} ${tokens.access_token}`,
					},
					redirect: "follow",
					body: JSON.stringify({
					  "job_id": job_id
					}),
				}
			)
			if(response.status == 200) {
				let res = (await response.json());
				result = {
					status: res.result_code,
					result: resultsMap[res.result_code] || res.result_note
				};
				clearTimeout(checkLoop.loop)
				return;
			}else if(response.status != 202){
				let res = (await response.text());
				try{
					let o = JSON.parse(res);
					result = {
						status: o.result_code,
						result: resultsMap[o.result_code] || o.result_note
					};	
				}catch(e){
					result = {
						status: -1,
						result: res
					};
				}
				clearTimeout(checkLoop.loop)
				return;
			}
			checkLoop.loop = setTimeout(checkLoop, 2000)
		}
		checkLoop.loop = setTimeout(checkLoop, 1200);
	}
	let root;
</script>

<div class="CompareModule" bind:this={root}>
	{#if result}
		<h1>{result.result}</h1>
		{#if result.status != 1}
			<LottiePlayer
			  src="anim/fail.json"
			  autoplay="{true}"
			  loop="{true}"
			  controls="{false}"
			  renderer="svg"
			  background="transparent"
			/>
		{:else}
			<LottiePlayer
			  src="anim/success.json"
			  autoplay="{true}"
			  loop="{false}"
			  controls="{false}"
			  renderer="svg"
			  background="transparent"
			/>
		{/if}
		<button class="button" on:click={() => dispatch('reset')} data-icon="keyboard_arrow_left">Try again</button>
		<img src="./img/logo-white.webp" alt="MyID" />
	{:else}
		<h1>Comparison</h1>
		<LottiePlayer
		  src="anim/circle.json"
		  autoplay="{true}"
		  controls="{false}"
		  loop={true}
		  renderer="svg"
		  background="transparent"
		/>
		<img src="./img/logo-white.webp" alt="MyID" />
	{/if}
</div>

<style>
	.CompareModule {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		color: white;
		font-size: 1.4em;
		background: #7b6acf;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding: 1em;
		padding-bottom: 2em;
		box-sizing: border-box;
	}
	.CompareModule > :global(*){
		position: relative;
		z-index: 1;
	}
	.CompareModule :global(svg){
		max-width: 20em;
		max-height: 20em;
		margin-bottom: 2em;
	}
	.button {
		background: #D625AE44;
		border: none;
		border-radius: 4px;
		color: white;
		padding: 0.7em 1.5em;
		min-width: 10em;
		cursor: pointer;
		margin-bottom: 3em;
	}

	.CompareModule :global(canvas) {
		display: block;
		/*transform: scaleX(-1);*/	
		height: 100%;
		left: 50%;
		transform: translateX(-50%);
		position: relative;
		position: absolute;
		top: 0;
		pointer-events: none;
		z-index: 0;
		opacity: 0;
		animation: fade-in 1s normal forwards ease;
	}
	@keyframes fade-in {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	img {
		max-width: 10em;
	}
</style>
